import axios from "@/libs/api.request";
// 获取批量信息
export const getAnalysis = data => {
  return axios.request({
    url: "/endpoint/analyze/agingList",
    method: "post",
    data
  });
};

export const getDetails = params => {
  return axios.request({
    url: "/endpoint/analyze/analyzeReportList",
    method: "GET",
    params
  });
};

export const exportAnalysis = data => {
  return axios.request({
    url: "/endpoint/analyze/exportExcel",
    method: "post",
    data
  });
};

export const getSelectType = data => {
  return axios.request({
    url: "/share/getSelectType",
    method: "post",
    data
  });
};
